import { SmthBanner } from '../../../shared/pages/opencallsPage/GetCompetitionItem/style';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { FlexBox, ResizedImage, useIsMobile } from '@brg/ui';
import { useMemo, useCallback, useEffect, useState } from 'react';
import { ProjectsSearchBar } from '../../../shared/components/projectsSearchBar/projectsSearchBar';
import { CompetitionAPI, Competition, API, Project, ProjectAPI } from '@brg/api';
import { useParams } from 'react-router-dom';
import { Outer } from 'shared/pages/explore/styles';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { ListOuter, ShortListLabel, WinnerDescription, WinnerPlace, WinnerProjectWrapper, WinnersBox, WinnerText } from './styles';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { ProjectsButchController } from 'core/controllers/ProjectsButchController';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ItemType } from 'shared/constants/itemType';
import { CompetitionShowMoreContent } from '../AllCompetitionsPage/styled';

export const PreShortListPage: FC<{ openLikeTab?: boolean, externalId?: string, showPreShortList?: boolean, activeTabKey?: string }> = ({ openLikeTab, externalId, showPreShortList, activeTabKey }) => {
    const { t, i18n } = useTranslation();
    const isMobile = useIsMobile();
    const [selectedTab, setSelectedTab] = useState('projects');
    const { id = externalId } = useParams<{ id: string }>();
    const [sorting, setSorting] = useState(1);
    const [time, setTime] = useState(Date.now());
    const [competition, setCompetition] = useState<Competition>();
    const [finalistsIds, setFinalistsIds] = useState<string[]>([]);
    const [winnerProjects, setWinnerProjects] = useState<{ project: Project, position: number }[]>([]);
    const [finalistsProjects, setFinalistsProjects] = useState<any[]>([]);
    const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);
    const [banMobileTabs , setBanMobileTabs] = useState<string[]>([''])

    // @ts-ignore
    const showProjects = useMemo(() => (competition?.nominations[0]?.showShortList), [ competition ])

    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
        setSorting(s);
        setTime(Date.now());
        }, []);

    const filterOpt = useMemo(() => ({
        isContextIgnored: true,
        projectFilter: sorting,
        projectStatus: [1],
        projectIds: finalistsIds,
        limit: 20
    }),[sorting, finalistsIds])

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                isCategoriesHidden={true}
                hideRightButtons
                hideLeftBar
                sorting={sorting}
                hideRightBar={true}
                onSortingChange={onSortingChange}
            />
        ),
        [onSortingChange, sorting],
    );

    //@ts-ignore
    const winnerIntroText = useMemo(() => (competition && competition?.winnerText_Intro ) , [competition])
    //@ts-ignore
    const winnerFinalText = useMemo(() => (competition && competition?.winnerText_Final ) , [competition])

    const [expanded, setExpanded] = useState(false);
    const [winnerExpanded, setWinnerExpanded] = useState(false);
    
    const handleDescriptionExpanded = () => {
        setExpanded((prev) => !prev);
      };
    const handleWinnerDescription = () => {
        setWinnerExpanded((prev) => !prev);
      };

    const ShowMore = (props: any) => (
        <CompetitionShowMoreContent
          {...props}
        >
          {props.children}
        </CompetitionShowMoreContent>
      )

    useEffect(() => {
        if (id) {
            CompetitionAPI.Get({ idCompetition: id})
            .then((r) => r.json())
            .then((v) => API.toLang<Competition>(v, i18n.language))
            .then((v) => {
              setCompetition(v);
            });
        }
    }, [id, i18n])

    useEffect(() => {
        if (competition) {
            //@ts-ignore
            const preFinalistsID: string[] = competition?.nominations[0]?.preFinalistsID

            if (preFinalistsID && preFinalistsID.length !== 0) {
                setFinalistsIds(preFinalistsID)
                Promise.all(preFinalistsID.map((idProject) =>
                    ProjectAPI.Get({ idProject })
                    .then((v) => v.json())
                    .then((v) => API.toLang<Project>(v, i18n.language))))
                    .then((v) => setFinalistsProjects(v));
            }
        }
    }, [competition, i18n.language])

    useEffect(() => {
        if (competition && competition?.juryID && competition?.juryID.length === 0) {
          setBanMobileTabs(['jury']);
        } else {
          setBanMobileTabs(['']);
        }
      }, [competition])

      if (openLikeTab) {
        return (
            <ListOuter style={{ marginTop: isMobile ? 0 : '24px', padding: 0}}>
                <FlexBox align="center" offsetTopMobile={10}>
                {searchBar}
                </FlexBox>
                {winnerIntroText && 
                    <WinnerDescription offsetBottom={32} offsetBottomMobile={24}>
                        <ShowMore 
                            importantStyles
                            more={t('show_more_text')}
                            less={t('show_less_text')}
                            lines={4}
                            expanded={expanded}
                            onClick={handleDescriptionExpanded}
                        >
                            {winnerIntroText}
                        </ShowMore>
                    </WinnerDescription>
                }
                <WinnersBox mobile={isMobile}>
                    {
                        !!winnerProjects?.length ? winnerProjects.map((winnerProject) => 
                        <WinnerProjectWrapper>
                            <WinnerPlace>
                                <WinnerText>{winnerProject.position}</WinnerText>
                                <WinnerText>{t('competition.short_list.place')}</WinnerText>
                            </WinnerPlace>
                            {/* @ts-ignore */}
                            <ProjectCardNew
                                {...computeProject(winnerProject.project)}
                                project={winnerProject.project}
                                sizeMult={1.36}
                                itemType={ItemType.shortlist}
                            />
                        </WinnerProjectWrapper>
                        ) : false
                    }
                </WinnersBox>
                {winnerFinalText && 
                    <WinnerDescription offsetTop={32} offsetTopMobile={24}>
                        <ShowMore 
                             importantStyles
                             more={t('show_more_text')}
                             less={t('show_less_text')}
                             lines={4}
                             expanded={winnerExpanded}
                             onClick={handleWinnerDescription}
                        >
                            {winnerFinalText}
                        </ShowMore>
                    </WinnerDescription>}
                {finalistsIds?.length > 0 && showProjects &&
                    (<FlexBox direction='column' directionMobile='column' offsetTopMobile={19}>
                    <ProjectsButchController
                        filter={filterOpt}
                        itemType={ItemType.competition}
                        date={time}
                        onProjectsLoaded={setFinalistsProjects} 
                    />
                </FlexBox>)
                }
            </ListOuter>
        )
    }

    return (
        <>
            <PopUpMenu
                key="menu-popup-deziiign"
                isVisible={visiblePopUp}
                onClose={() => setIsVisiblePopUp(false)}
                activeTab={selectedTab}
                showOnlyTabs
                banTabs={banMobileTabs}
            />
            <Outer style={{ marginTop: '64px'}}>
                <SmthBanner isHideMarginBottom isMobile={isMobile}>
                    <ResizedImage files={competition?.titleImages} />
                </SmthBanner>
                <FlexBox align="center" offsetTop={32}>
                {searchBar}
                </FlexBox>
                <WinnersBox mobile={isMobile}>
                    {
                        !!winnerProjects?.length ? winnerProjects.map((winnerProject) => 
                        <WinnerProjectWrapper>
                            <WinnerPlace>
                                <WinnerText>{winnerProject.position}</WinnerText>
                                <WinnerText>{t('competition.short_list.place')}</WinnerText>
                            </WinnerPlace>
                            {/* @ts-ignore */}
                            <ProjectCardNew
                                {...computeProject(winnerProject.project)}
                                project={winnerProject.project}
                                sizeMult={1.36}
                                itemType={ItemType.shortlist}
                            />
                        </WinnerProjectWrapper>
                        ) : false
                    }
                </WinnersBox>
                {finalistsIds?.length > 0 && showProjects &&
                    (<FlexBox direction='column' directionMobile='column' offsetTopMobile={19}>
                    <ShortListLabel>{t('competition.short_list.shortlist')}</ShortListLabel>
                    <ProjectsButchController
                        filter={filterOpt}
                        date={time}
                        onProjectsLoaded={setFinalistsProjects} 
                    />
                </FlexBox>)
                }
            </Outer>
        </>
    );
};
import { SmthBanner } from '../../../shared/pages/opencallsPage/GetCompetitionItem/style';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { FlexBox, ResizedImage, useIsMobile } from '@brg/ui';
import { useMemo, useCallback, useEffect, useState } from 'react';
import { ProjectsSearchBar } from '../../../shared/components/projectsSearchBar/projectsSearchBar';
import { CompetitionAPI, Competition, API, Project, ProjectAPI } from '@brg/api';
import { useParams } from 'react-router-dom';
import { Outer } from 'shared/pages/explore/styles';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { ListOuter, ShortListLabel, WinnerDescription, WinnerPlace, WinnerProjectWrapper, WinnersBox, WinnerText } from './styles';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { ProjectsButchController } from 'core/controllers/ProjectsButchController';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ItemType } from 'shared/constants/itemType';
import { CompetitionShowMoreContent } from '../AllCompetitionsPage/styled';

export const PreShortListPage: FC<{ openLikeTab?: boolean, externalId?: string, showPreShortList?: boolean, activeTabKey?: string }> = ({ openLikeTab, externalId, showPreShortList, activeTabKey }) => {
    const { t, i18n } = useTranslation();
    const isMobile = useIsMobile();
    const [selectedTab, setSelectedTab] = useState('projects');
    const { id = externalId } = useParams<{ id: string }>();
    const [sorting, setSorting] = useState(1);
    const [time, setTime] = useState(Date.now());
    const [competition, setCompetition] = useState<Competition>();
    const [finalistsIds, setFinalistsIds] = useState<string[]>([]);
    const [winnerProjects, setWinnerProjects] = useState<{ project: Project, position: number }[]>([]);
    const [finalistsProjects, setFinalistsProjects] = useState<any[]>([]);
    const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);
    const [banMobileTabs , setBanMobileTabs] = useState<string[]>([''])

    // @ts-ignore
    const showProjects = useMemo(() => (competition?.nominations[0]?.showShortList), [ competition ])

    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
        setSorting(s);
        setTime(Date.now());
        }, []);

    const filterOpt = useMemo(() => ({
        isContextIgnored: true,
        projectFilter: sorting,
        projectStatus: [1],
        projectIds: finalistsIds,
        limit: 20
    }),[sorting, finalistsIds])

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                isCategoriesHidden={true}
                hideRightButtons
                hideLeftBar
                sorting={sorting}
                hideRightBar={true}
                onSortingChange={onSortingChange}
            />
        ),
        [onSortingChange, sorting],
    );

    //@ts-ignore
    const winnerIntroText = useMemo(() => (competition && competition?.winnerText_Intro ) , [competition])
    //@ts-ignore
    const winnerFinalText = useMemo(() => (competition && competition?.winnerText_Final ) , [competition])

    const [expanded, setExpanded] = useState(false);
    const [winnerExpanded, setWinnerExpanded] = useState(false);
    
    const handleDescriptionExpanded = () => {
        setExpanded((prev) => !prev);
      };
    const handleWinnerDescription = () => {
        setWinnerExpanded((prev) => !prev);
      };

    const ShowMore = (props: any) => (
        <CompetitionShowMoreContent
          {...props}
        >
          {props.children}
        </CompetitionShowMoreContent>
      )

    useEffect(() => {
        if (id) {
            CompetitionAPI.Get({ idCompetition: id})
            .then((r) => r.json())
            .then((v) => API.toLang<Competition>(v, i18n.language))
            .then((v) => {
              setCompetition(v);
            });
        }
    }, [id, i18n])

    useEffect(() => {
        if (competition) {
            //@ts-ignore
            const preFinalistsID: string[] = competition?.nominations[0]?.preFinalistsID

            if (preFinalistsID && preFinalistsID.length !== 0) {
                setFinalistsIds(preFinalistsID)
                Promise.all(preFinalistsID.map((idProject) =>
                    ProjectAPI.Get({ idProject })
                    .then((v) => v.json())
                    .then((v) => API.toLang<Project>(v, i18n.language))))
                    .then((v) => setFinalistsProjects(v));
            }
        }
    }, [competition, i18n.language])

    useEffect(() => {
        if (competition && competition?.juryID && competition?.juryID.length === 0) {
          setBanMobileTabs(['jury']);
        } else {
          setBanMobileTabs(['']);
        }
      }, [competition])

      if (openLikeTab) {
        return (
            <ListOuter style={{ marginTop: isMobile ? 0 : '24px', padding: 0}}>
                <FlexBox align="center" offsetTopMobile={10}>
                {searchBar}
                </FlexBox>
                {winnerIntroText && 
                    <WinnerDescription offsetBottom={32} offsetBottomMobile={24}>
                        <ShowMore 
                            importantStyles
                            more={t('show_more_text')}
                            less={t('show_less_text')}
                            lines={4}
                            expanded={expanded}
                            onClick={handleDescriptionExpanded}
                        >
                            {winnerIntroText}
                        </ShowMore>
                    </WinnerDescription>
                }
                <WinnersBox mobile={isMobile}>
                    {
                        !!winnerProjects?.length ? winnerProjects.map((winnerProject) => 
                        <WinnerProjectWrapper>
                            <WinnerPlace>
                                <WinnerText>{winnerProject.position}</WinnerText>
                                <WinnerText>{t('competition.short_list.place')}</WinnerText>
                            </WinnerPlace>
                            {/* @ts-ignore */}
                            <ProjectCardNew
                                {...computeProject(winnerProject.project)}
                                project={winnerProject.project}
                                sizeMult={1.36}
                                itemType={ItemType.shortlist}
                            />
                        </WinnerProjectWrapper>
                        ) : false
                    }
                </WinnersBox>
                {winnerFinalText && 
                    <WinnerDescription offsetTop={32} offsetTopMobile={24}>
                        <ShowMore 
                             importantStyles
                             more={t('show_more_text')}
                             less={t('show_less_text')}
                             lines={4}
                             expanded={winnerExpanded}
                             onClick={handleWinnerDescription}
                        >
                            {winnerFinalText}
                        </ShowMore>
                    </WinnerDescription>}
                {finalistsIds?.length > 0 && showProjects &&
                    (<FlexBox direction='column' directionMobile='column' offsetTopMobile={19}>
                    <ProjectsButchController
                        filter={filterOpt}
                        itemType={ItemType.competition}
                        date={time}
                        onProjectsLoaded={setFinalistsProjects} 
                    />
                </FlexBox>)
                }
            </ListOuter>
        )
    }

    return (
        <>
            <PopUpMenu
                key="menu-popup-deziiign"
                isVisible={visiblePopUp}
                onClose={() => setIsVisiblePopUp(false)}
                activeTab={selectedTab}
                showOnlyTabs
                banTabs={banMobileTabs}
            />
            <Outer style={{ marginTop: '64px'}}>
                <SmthBanner isHideMarginBottom isMobile={isMobile}>
                    <ResizedImage files={competition?.titleImages} />
                </SmthBanner>
                <FlexBox align="center" offsetTop={32}>
                {searchBar}
                </FlexBox>
                <WinnersBox mobile={isMobile}>
                    {
                        !!winnerProjects?.length ? winnerProjects.map((winnerProject) => 
                        <WinnerProjectWrapper>
                            <WinnerPlace>
                                <WinnerText>{winnerProject.position}</WinnerText>
                                <WinnerText>{t('competition.short_list.place')}</WinnerText>
                            </WinnerPlace>
                            {/* @ts-ignore */}
                            <ProjectCardNew
                                {...computeProject(winnerProject.project)}
                                project={winnerProject.project}
                                sizeMult={1.36}
                                itemType={ItemType.shortlist}
                            />
                        </WinnerProjectWrapper>
                        ) : false
                    }
                </WinnersBox>
                {finalistsIds?.length > 0 && showProjects &&
                    (<FlexBox direction='column' directionMobile='column' offsetTopMobile={19}>
                    <ShortListLabel>{t('competition.short_list.shortlist')}</ShortListLabel>
                    <ProjectsButchController
                        filter={filterOpt}
                        date={time}
                        onProjectsLoaded={setFinalistsProjects} 
                    />
                </FlexBox>)
                }
            </Outer>
        </>
    );
};
